import { z } from 'zod';
import { DateSchema, ObjectIdSchema } from './base';
import { DeviceClasses, TrackerActivationSchema, TrackerStateSchema } from './trackers';

export const TagEntry = z.object({
  value: z.string(),
  label: z.string().optional(),
  count: z.number().optional(),
});

export type TagEntry = z.infer<typeof TagEntry>;

export const TagsSchema = z.map(z.string(), z.array(TagEntry));

export type TagsCollection = z.infer<typeof TagsSchema>;

export const StarterSchema = z.object({
  id: ObjectIdSchema,
  startNumber: z.string(),
  eventId: ObjectIdSchema,
  name: z.string(),
  trackId: ObjectIdSchema.optional(),
  appId: z.string().optional(),
  deviceType: z.string().nullable(),
  deviceClass: z.nativeEnum(DeviceClasses).nullable(),
  times: z.record(z.string(), DateSchema),
  manualFinishDuration: z.number().nullable(),
  keyUsed: z.boolean(),
  key: z.string().optional(),
  startTime: DateSchema.nullish(),
  endTime: DateSchema.nullish(),
  markerColor: z.string(),
  integrations: z.object({
    importId: z.string().optional(),
    raceresultKey: z.string().optional(),
    genericImportKey: z.string().optional(),
    messagingToken: z.string().nullish(),
  }),
  tags: z.record(z.string(), z.string()),
  updatedAt: DateSchema,
  createdAt: DateSchema.optional(),
  gpxUrl: z.string().optional(),
  listPosition: z.number().optional(),
  deviceGpxFix: z.boolean().optional(),
  deviceName: z.string().optional(),
  deviceActivation: TrackerActivationSchema.optional(),
  deviceState: TrackerStateSchema.optional(),
  deviceId: ObjectIdSchema.nullish(),
});

export type Starter = z.infer<typeof StarterSchema>;

export const StartersSchema = z.array(StarterSchema);
export type Starters = z.infer<typeof StartersSchema>;
